var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _path12, _circle2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmeLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC3D5;}\n\t.st1{fill:#ACC8D5;}\n\t.st2{fill:#63BCE7;}\n\t.st3{fill:#63E2E7;}\n\t.st4{fill:#6C777A;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#04B354;}\n\t.st7{fill:#F8AF23;}\n\t.st8{fill:#3F3679;}\n\t.st9{fill:#E1C783;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.9,
    y: 67.1,
    className: "st0",
    width: 24.2,
    height: 20.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7,
    y: 35.3,
    className: "st0",
    width: 121.2,
    height: 52.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7,
    y: 35.3,
    className: "st0",
    width: 15.5,
    height: 52.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 177.4,
    y: 35.3,
    className: "st1",
    width: 15.5,
    height: 52.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 87.4,
    className: "st0",
    width: 169.7,
    height: 116.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 87.4,
    className: "st0",
    width: 15.5,
    height: 116.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.7,
    y: 87.4,
    className: "st1",
    width: 15.5,
    height: 116.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2,
    y: 203.7,
    className: "st2",
    width: 196.3,
    height: 11.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 203.7,
    className: "st3",
    width: 15.5,
    height: 11.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 215.2,
    className: "st2",
    width: 211.1,
    height: 11.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 215.2,
    className: "st3",
    width: 15.5,
    height: 11.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 119.1,
    className: "st4",
    width: 46.7,
    height: 84.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.9,153.6h2.7c1,0,1.9,0.8,1.9,1.9v11.9c0,1-0.8,1.9-1.9,1.9h-2.7c-1,0-1.9-0.8-1.9-1.9v-11.9 C115.1,154.4,115.9,153.6,116.9,153.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.5,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8c0,0,0,0,0,0h-5.3c-3.8,0-6.8-3-6.8-6.8l0,0L47.5,87.4L47.5,87.4z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63,87.4H47.5v16.3c0,3.8,3,6.8,6.8,6.8c0,0,0,0,0,0h5.3c2,0,3.8-0.8,5.1-2.3c-1.1-1.2-1.7-2.8-1.7-4.5L63,87.4 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M66.3,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8l0,0h-5.3c-3.8,0-6.8-3-6.8-6.8l0,0L66.3,87.4L66.3,87.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.2,87.4H104l0,0v16.3c0,3.8-3,6.8-6.8,6.8l0,0H92c-3.8,0-6.8-3-6.8-6.8l0,0V87.4L85.2,87.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8l0,0h-5.3c-3.8,0-6.8-3-6.8-6.8l0,0L104,87.4L104,87.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.9,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-3.8,0-6.8-3-6.8-6.8l0,0L122.9,87.4L122.9,87.4 L122.9,87.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.8,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-3.8,0-6.8-3-6.8-6.8L141.8,87.4L141.8,87.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M160.6,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-3.8,0-6.8-3-6.8-6.8L160.6,87.4L160.6,87.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.5,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-3.8,0-6.8-3-6.8-6.8L179.5,87.4L179.5,87.4L179.5,87.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.3,87.4h18.9l0,0v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-3.8,0-6.8-3-6.8-6.8L198.3,87.4L198.3,87.4z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 67.1,
    className: "st1",
    width: 24.2,
    height: 20.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 67.1,
    className: "st6",
    width: 15.5,
    height: 20.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 201.7,
    y: 67.1,
    className: "st6",
    width: 15.5,
    height: 20.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 126.8,
    className: "st4",
    width: 30.7,
    height: 40.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 171.1,
    y: 126.8,
    className: "st4",
    width: 30.7,
    height: 40.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 132.3,
    cy: 52.9,
    r: 34.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M146.9,52.8v10c0,0.8-0.3,1.5-0.9,2c-0.5,0.6-1.3,0.9-2.1,0.9h-8.8v7.1c0,0.8-0.3,1.5-0.9,2.1 c-0.5,0.5-1.3,0.9-2,0.8c-0.8,0-1.5-0.3-2.1-0.8c-0.6-0.5-0.9-1.3-0.9-2.1v-7.1h-8.7c-0.8,0-1.5-0.3-2-0.8c-0.6-0.5-0.9-1.3-0.9-2 c0-1.6,1.3-2.9,2.9-2.9c0,0,0,0,0,0H141v-4.2h-20.4c-0.8,0-1.5-0.3-2-0.8c-0.6-0.5-0.9-1.3-0.8-2.1v-10c0-1.6,1.3-2.9,2.9-2.9 c0,0,0,0,0,0h8.7v-7.1c0-1.6,1.2-2.9,2.8-2.9c0.1,0,0.1,0,0.2,0c0.8,0,1.5,0.3,2,0.8c0.6,0.5,0.9,1.3,0.8,2V40h8.9 c0.8,0,1.5,0.3,2.1,0.9c0.6,0.5,0.9,1.3,0.9,2c0,1.6-1.3,2.9-3,3h-20.5V50H144c0.8,0,1.5,0.3,2.1,0.9 C146.6,51.3,146.9,52.1,146.9,52.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 47.5,
    cy: 142.1,
    r: 23.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M39.9,142.1c0-9.7,6.1-18.4,15.3-21.7c-12-4.3-25.2,2-29.5,14s2,25.2,14,29.5c5,1.8,10.5,1.8,15.5,0 C46,160.6,39.9,151.9,39.9,142.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.3,165.2h8.4c13.9,0,25.1,11.2,25.1,25.1l0,0v36.3l0,0H18.1l0,0v-36.3C18.1,176.4,29.4,165.2,43.3,165.2 C43.3,165.2,43.3,165.2,43.3,165.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,165.5c-1.2-0.2-2.4-0.3-3.5-0.3h-8.4c-13.9,0-25.1,11.2-25.1,25.1l0,0v36.3h15.5v-36.3 C33.6,177.8,42.9,167.2,55.2,165.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.7,87.4h15.5v16.3c0,3.8-3,6.8-6.8,6.8h-5.3c-2,0-3.8-0.8-5.1-2.3c1.1-1.2,1.7-2.8,1.7-4.5L201.7,87.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.9,170.7h2.7c1.9,0,3.4-1.5,3.4-3.4v-11.9c0-1.9-1.5-3.4-3.4-3.4h-2.7c-1.9,0-3.4,1.5-3.4,3.4v11.9 C113.6,169.2,115.1,170.7,116.9,170.7z M116.6,155.4c0-0.2,0.2-0.4,0.4-0.4h2.7c0.2,0,0.4,0.2,0.4,0.4v11.9c0,0.2-0.2,0.4-0.4,0.4 h-2.7c-0.2,0-0.4-0.2-0.4-0.4V155.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.8,125.3h-30.7c-0.8,0-1.5,0.7-1.5,1.5v40.8c0,0.8,0.7,1.5,1.5,1.5h30.7c0.8,0,1.5-0.7,1.5-1.5v-40.8 C203.3,125.9,202.6,125.3,201.8,125.3C201.8,125.3,201.8,125.3,201.8,125.3z M200.3,166.1h-27.7v-37.8h27.7L200.3,166.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.3,236.1h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S28.2,236.1,27.3,236.1 L27.3,236.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.7,236.1h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S247.5,236.1,246.7,236.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M218.5,236.1h-181c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h181c0.8,0,1.5-0.7,1.5-1.5S219.3,236.1,218.5,236.1z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.3,228.1h237.4c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-7.3v-10c0-0.8-0.7-1.5-1.5-1.5H232v-10 c0-0.8-0.7-1.5-1.5-1.5h-11.8V88.9h12.6c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-12.6V67.1c0-0.8-0.7-1.5-1.5-1.5h-22.7V35.3 c0-0.8-0.7-1.5-1.5-1.5h-30.1c-10.5-16.8-32.7-22-49.5-11.5c-4.6,2.9-8.6,6.8-11.5,11.5H71.7c-0.8,0-1.5,0.7-1.5,1.5v30.3H47.5 c-0.8,0-1.5,0.7-1.5,1.5v18.8H33.4c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H46v28.8c-13.5,0.8-23.8,12.5-23,26c0.5,9,6,17,14.2,20.8 c-12,2.8-20.5,13.6-20.5,25.9v34.8H9.3c-0.8,0-1.5,0.7-1.5,1.5S8.5,228.1,9.3,228.1L9.3,228.1z M236.4,225.1h-158v-8.5h158V225.1z  M229,213.7H78.3v-8.5H229V213.7z M154.2,202.2h-43.7v-81.6h43.7L154.2,202.2z M157.2,202.2v-83.1c0-0.8-0.7-1.5-1.5-1.5H109 c-0.8,0-1.5,0.7-1.5,1.5v83.1H78.3v-11.9c0-8.4-3.9-16.2-10.6-21.3h25.9c0.8,0,1.5-0.7,1.5-1.5v-40.8c0-0.8-0.7-1.5-1.5-1.5H65.3 c-4.3-4.5-10.1-7.3-16.3-7.6V110c1.5,1.2,3.4,1.9,5.3,1.9h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3 c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3c2.7,0,5.2-1.3,6.8-3.5 c1.5,2.2,4.1,3.5,6.8,3.5h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5 h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3c2.7,0,5.2-1.3,6.8-3.5c1.5,2.2,4.1,3.5,6.8,3.5h5.3c1.9,0,3.8-0.7,5.3-1.9 v92.2L157.2,202.2z M64.4,159.9c8.8-8.3,10.2-21.7,3.4-31.7h24.4v37.8H64.4V159.9z M61.4,165.5c-1.2-0.5-2.4-0.8-3.6-1.1 c1.2-0.6,2.4-1.3,3.6-2V165.5z M49,88.8h15.9v14.8c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3L49,88.8z M71.7,88.8h12v14.8 c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3V88.8H71.7z M102.5,88.8v14.8c0,2.9-2.4,5.3-5.3,5.3H92c-2.9,0-5.3-2.4-5.3-5.3 V88.8H102.5z M121.4,88.8v14.8c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3V88.8H121.4z M178,88.8v14.8 c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3V88.8H178z M192.9,88.8h3.9v14.8c0,2.9-2.4,5.3-5.3,5.3h-5.3 c-2.9,0-5.3-2.4-5.3-5.3V88.8H192.9z M215.7,88.8v14.8c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3V88.8H215.7z M159.1,103.7 c0,2.9-2.4,5.3-5.3,5.3h-5.3c-2.9,0-5.3-2.4-5.3-5.3V88.8h15.9L159.1,103.7z M140.3,88.8v14.8c0,2.9-2.4,5.3-5.3,5.3h-5.3 c-2.9,0-5.3-2.4-5.3-5.3V88.8H140.3z M215.7,68.6v17.3h-21.2V68.6H215.7z M191.4,36.8v49.1h-44.8c18.2-7.9,26.6-29.1,18.6-47.3 c-0.3-0.6-0.5-1.2-0.8-1.8H191.4z M132.3,19.9c18.2,0,33,14.8,33,33s-14.8,33-33,33s-33-14.8-33-33l0,0 C99.4,34.7,114.1,19.9,132.3,19.9z M73.2,36.8h26.9c-8.9,17.8-1.7,39.3,16.1,48.2c0.6,0.3,1.2,0.6,1.8,0.8H73.2V36.8z M49,68.6h21.2 v17.3H49V68.6z M25.9,142.1c0-11.9,9.7-21.6,21.6-21.6S69,130.2,69,142.1c0,11.9-9.7,21.6-21.6,21.6c0,0,0,0,0,0 C35.6,163.7,25.9,154,25.9,142.1z M19.6,190.3c0-13,10.6-23.6,23.6-23.6h8.4c13,0,23.6,10.6,23.6,23.6v34.8H19.6V190.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmeLoan);
export default __webpack_public_path__ + "static/media/SMELoan.2b06cad72226c8335cbf77fa8f2a4aa5.svg";
export { ForwardRef as ReactComponent };